query Company($id: String) {
  company(id: $id) {
    id
    vouchers {
      type
      code
      expiresAt
    }
  }
}
